import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

/**
 * MobileSectionMenu — phone-only (<640px) dropdown for sub-page section tabs.
 * Mirrors the main app's mobile nav styling. Desktop pill rows stay untouched
 * (give them `hidden sm:flex`).
 * items: [{ id, label, icon: Component, badge?: ReactNode }]
 */
export const MobileSectionMenu = ({ items, activeId, onChange, testIdPrefix = 'section-menu', placeholder = 'Select Section' }) => {
  const [open, setOpen] = useState(false);
  if (!items || items.length === 0) return null;
  const activeItem = items.find(i => i.id === activeId);
  const ActiveIcon = activeItem?.icon;
  return (
    <div className="relative sm:hidden" data-testid={`${testIdPrefix}-mobile-dropdown`}>
      <button
        type="button"
        onClick={() => setOpen(v => !v)}
        aria-expanded={open}
        className="flex w-full items-center justify-between gap-3 rounded-xl border border-slate-200 dark:border-slate-700 bg-card px-4 py-3 text-base font-semibold text-foreground shadow-sm"
        data-testid={`${testIdPrefix}-mobile-trigger`}
      >
        <span className="flex items-center gap-3 min-w-0">
          {ActiveIcon && <ActiveIcon className="w-5 h-5 shrink-0 text-[#2563eb]" />}
          <span className="truncate">{activeItem?.label || placeholder}</span>
          {activeItem?.badge}
        </span>
        <ChevronDown className={`w-5 h-5 shrink-0 text-muted-foreground transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <>
          <button
            type="button"
            className="fixed inset-0 z-[1040] bg-black/10"
            onClick={() => setOpen(false)}
            aria-label="Close section menu"
            data-testid={`${testIdPrefix}-mobile-backdrop`}
          />
          <div className="absolute left-0 right-0 top-full z-[1090] mt-2 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 p-2 shadow-2xl space-y-1" data-testid={`${testIdPrefix}-mobile-menu`}>
            {items.map(item => {
              const isActive = item.id === activeId;
              const Icon = item.icon;
              return (
                <button
                  key={item.id}
                  type="button"
                  onClick={() => { onChange(item.id); setOpen(false); }}
                  className={`flex w-full min-h-[48px] items-center gap-3.5 px-4 py-3 rounded-xl text-base font-semibold transition-colors ${isActive
                    ? 'bg-[#2563eb] text-white'
                    : 'text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800'
                  }`}
                  data-testid={`${testIdPrefix}-mobile-item-${item.id}`}
                >
                  {Icon && <Icon className="w-5 h-5 shrink-0" />}
                  <span className="truncate">{item.label}</span>
                  {item.badge}
                </button>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};
